import { postJson } from 'api/baseApi'

export const addFolder = function (data) {
  return postJson({ url: `/api/server/folders`, data: data })
}



// WEBPACK FOOTER //
// ./src/api/treemenuOldApi.js